import type { TField } from "@shared/types/form";
import { TextField } from "./text-field";
import { useFieldContext } from ".";

export function NumberField({ label, ...props }: TField) {
	const field = useFieldContext();
	return (
		<TextField
			label={label}
			onChange={(e) => field.handleChange(e.target.valueAsNumber)}
			inputMode="numeric"
			{...props}
		/>
	);
}
